import React from 'react';
import _ from 'lodash';

import {
  SaveSoftwareVersionInput,
  useSaveSoftwareVersionsMutation,
  useSoftwareVersionsWidgetQuery
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useSoftwareVersionsWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        formState: {
          softwareVersions: _.map(tuple.data?.store?.softwareVersions ?? [], (softwareVersion): types.ISoftwareVersion => ({
            id: softwareVersion.id,
            name: softwareVersion.name
          }))
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveSoftwareVersions(storeId: string) {
  const [fnMutate, tuple] = useSaveSoftwareVersionsMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            storeId,
            softwareVersions: _.map(formState.softwareVersions, (softwareVersion) : SaveSoftwareVersionInput => ({
              id: softwareVersion.id || undefined,
              name: softwareVersion.name
            }))
          }
        }
      });
    },
    [
      storeId,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
